import React from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import ErrorScreen from "./ErrorScreen";

const ROUTE_MESSAGES = {
  403: "The requested resource is forbidden.",
  404: "The requested resource could not be found but may be available again in the future.",
};

const SERVER_MESSAGE =
  "An unexpected condition was encountered. Our service team has been dispatched to bring it back online.";

function resolveRouteError(error) {
  const status = error.status || 404;
  const family = Math.floor(status / 100);

  if (family === 5) {
    return {
      variant: "server",
      statusCode: String(status),
      message: SERVER_MESSAGE,
    };
  }

  if (status === 403) {
    return {
      variant: "forbidden",
      statusCode: "403",
      message: ROUTE_MESSAGES[403],
    };
  }

  return {
    variant: "notFound",
    statusCode: String(status),
    message: error.statusText || ROUTE_MESSAGES[404],
  };
}

/**
 * Used as errorElement on the root React Router route.
 *
 * isRouteErrorResponse → routing / loader error  → ErrorScreen with status code
 * otherwise            → JS / render error        → ErrorScreen "crash" variant
 */
export default function RootErrorElement() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    const { variant, statusCode, message } = resolveRouteError(error);
    return (
      <ErrorScreen
        variant={variant}
        statusCode={statusCode}
        message={message}
      />
    );
  }

  return <ErrorScreen variant="crash" />;
}
